<script lang="ts">
    import MainStore from "@src/model/Main.Store";
    
    export let text: string = '';
    export let target: string|undefined = undefined;
    
    
        
    let inputElem: HTMLInputElement;
    function handlePromptClick() {
        MainStore.setCurrentExecutingInteractionPoint(undefined);
        MainStore.getValue().currentSessionData.set(target, inputElem.value);
        MainStore.getValue()._currentVideoElement?.play();
    }
    </script>
    
    
    <div class="main-overlay-prompt">
        {text}
   
        <input bind:this={inputElem} />
        <div>
            <button on:click={handlePromptClick}>OK</button>
        </div>
    </div>
    
    
    <style>
        .main-overlay-prompt {
            padding: 1rem;
        }
    </style>
    